import { useInstantSearch } from 'react-instantsearch';
import * as Styled from './NoResults.styled';

export const NoResults = () => {
  const { results, status } = useInstantSearch();

  if (!results || results.nbHits > 0 || status === 'loading' || status === 'stalled') {
    return null;
  }

  return (
    <Styled.Wrapper>
      <Styled.Message>Sorry, no results found</Styled.Message>
      <Styled.Image
        alt="Sorry, no results found"
        src="/Styles/Images/noresults.png"
      />
    </Styled.Wrapper>
  );
};
